/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type settlingin_ParentSettlingInPlanResponse = {
    /**
     * CaregiverFirstname is the first name of the caregiver named on most schedule days
     * (detail only)
     */
    caregiver_firstname?: string;
    /**
     * ChildFirstname is the child's first name
     */
    child_firstname: string;
    /**
     * ChildID is the child in settling-in (one of the caller's children)
     */
    child_id: string;
    /**
     * ChildLastname is the child's last name
     */
    child_lastname: string;
    /**
     * ChildcareName is the child's childcare
     */
    childcare_name: string;
    /**
     * DateAgreed reports that the start date was agreed with the family
     */
    date_agreed: boolean;
    /**
     * EndDate is the planned or recorded last day
     */
    end_date?: string;
    /**
     * GroupName is the child's group
     */
    group_name: string;
    /**
     * ID is the plan id
     */
    id: string;
    /**
     * InfoConfirmed reports that the family confirmed the information
     */
    info_confirmed: boolean;
    /**
     * InfoSent reports that the settling-in information was sent to the family
     */
    info_sent: boolean;
    /**
     * SettlingInCompleted reports that the staff marked the settling-in completed
     */
    settling_in_completed: boolean;
    /**
     * SignOffChannel is where the sign-off was recorded: admin (office) or app (parent app)
     */
    sign_off_channel?: settlingin_ParentSettlingInPlanResponse.sign_off_channel;
    /**
     * SignOffDate is the sign-off date
     */
    sign_off_date?: string;
    /**
     * SignedOff reports that the plan is signed off
     */
    signed_off: boolean;
    /**
     * StartDate is the first settling-in day
     */
    start_date: string;
    /**
     * Status is the parent-safe stage of the plan
     */
    status: settlingin_ParentSettlingInPlanResponse.status;
};
export namespace settlingin_ParentSettlingInPlanResponse {
    /**
     * SignOffChannel is where the sign-off was recorded: admin (office) or app (parent app)
     */
    export enum sign_off_channel {
        ADMIN = 'admin',
        APP = 'app',
    }
    /**
     * Status is the parent-safe stage of the plan
     */
    export enum status {
        PLANNED = 'planned',
        RUNNING = 'running',
        COMPLETED = 'completed',
        SIGNED_OFF = 'signed_off',
    }
}

